import { RouteObject, createBrowserRouter } from 'react-router-dom';

import RequireAuth from '@/components/auth/RequireAuth';
import AdminEvent from '@/pages/adminEvent/AdminEvent';
import ConfirmPassword from '@/pages/auth/ConfirmPassword';
import ConfirmUser from '@/pages/auth/ConfirmUser';
import ForgotPassword from '@/pages/auth/ForgotPassword';
import ResendConfirmationCode from '@/pages/auth/ResendConfirmationCode';
import SignIn from '@/pages/auth/SignIn';
import SignOut from '@/pages/auth/SignOut';
import SignUp from '@/pages/auth/SignUp';
import Blog from '@/pages/blog/Blog';
import Category from '@/pages/category/Category';
import AllCommments from '@/pages/comments/AllComments';
import Commments from '@/pages/comments/comments';
import Events from '@/pages/events/Events';
import Group from '@/pages/group/Group';
import NewsLetter from '@/pages/newsLetter/NewsLetter';
import AllNotifications from '@/pages/notifications/all_notifications';
import NewNotifications from '@/pages/notifications/new_notification';
import Threads from '@/pages/threads/Threads';
import Users from '@/pages/users/Users';

import Root from '@pages/Root';
import About from '@pages/about/About';
import Home from '@pages/home/Home';
import Testimonial from '@/pages/testimonial/Testimonial';

const authentication: RouteObject[] = [
	{
		path: '/auth/sign-in',
		element: <SignIn />,
	},
	{
		path: '/auth/sign-up',
		element: <SignUp />,
	},
	{
		path: '/auth/confirm-user',
		element: <ConfirmUser />,
	},
	{
		path: '/auth/confirm-password',
		element: <ConfirmPassword />,
	},
	{
		path: '/auth/resend-confirmation-code',
		element: <ResendConfirmationCode />,
	},
	{
		path: '/auth/forgot-password',
		element: <ForgotPassword />,
	},
	{
		path: '/auth/sign-out',
		element: <SignOut />,
	},
];

const router = createBrowserRouter([
	{
		path: '/',
		element: <Root />,
		children: [
			{
				index: true,
				path: '/',
				element: (
					<RequireAuth>
						<Home />
					</RequireAuth>
				),
			},
			{
				path: '/about',
				element: (
					<RequireAuth>
						<About />
					</RequireAuth>
				),
			},
			{
				path: '/userevents',
				element: (
					<RequireAuth>
						<Events />
					</RequireAuth>
				),
			},
			{
				path: '/events',
				element: (
					<RequireAuth>
						<AdminEvent />
					</RequireAuth>
				),
			},
			{
				path: '/threads',
				element: (
					<RequireAuth>
						<Threads />
					</RequireAuth>
				),
			},
			{
				path: '/category',
				element: (
					<RequireAuth>
						<Category />
					</RequireAuth>
				),
			},
			{
				path: '/users',
				element: (
					<RequireAuth>
						<Users />
					</RequireAuth>
				),
			},
			{
				path: '/send-notification',
				element: (
					<RequireAuth>
						<NewNotifications />
					</RequireAuth>
				),
			},
			{
				path: '/notifications',
				element: (
					<RequireAuth>
						<AllNotifications />
					</RequireAuth>
				),
			},
			{
				path: '/groups',
				element: (
					<RequireAuth>
						<Group />
					</RequireAuth>
				),
			},
			{
				path: '/blog',
				element: (
					<RequireAuth>
						<Blog />
					</RequireAuth>
				),
			},
			{
				path: '/newsLetter',
				element: (
					<RequireAuth>
						<NewsLetter />
					</RequireAuth>
				),
			},
			{
				path: '/comments',
				element: (
					<RequireAuth>
						<AllCommments />
					</RequireAuth>
				),
			},
			{
				path: '/testimonial',
				element: (
					<RequireAuth>
						< Testimonial/>
					</RequireAuth>
				),
			},
			{
				path: '/comments/:type/:id',
				element: (
					<RequireAuth>
						<Commments />
					</RequireAuth>
				),
			},
			...authentication,
		],
	},
]);

// const router = createBrowserRouter([
// 	{
// 		path: '/',
// 		element: <Root />,
// 		children: [
// 			{
// 				index: true,
// 				path: '/',
// 				element: (
// 					<Home />
// 				),
// 			},
// 			{
// 				path: '/about',
// 				element: (<About />),
// 			},
// 			{
// 				path: '/userevents',
// 				element: (<Events />),
// 			},
// 				{
// 				path: '/events',
// 				element: (<AdminEvent />),
// 			},
// 			{
// 				path: '/threads',
// 				element: (<Threads />),
// 			},
// 			{
// 				path: '/category',
// 				element: (<Category />),
// 			},
// 			{
// 				path: '/users',
// 				element: (
// 					<Users />
// 				),
// 			},
// 			{
// 				path: '/blog',
// 				element: (<Blog />),
// 			},
// 			{
// 				path: '/newsLetter',
// 				element: (<NewsLetter />),
// 			},
// 			{
// 				path: '/comments',
// 				element: (<AllCommments />),
// 			},
// 			{
// 				path: '/comments/:type/:id',
// 				element: (<Commments />),
// 			},
// 			{
// 				path: '/send-notification',
// 				element: (<NewNotifications />),
// 			},
// 			{
// 				path: '/notifications',
// 				element: (<AllNotifications />),
// 			},
// 			{
// 				path: '/groups',
// 				element: (<Group />),
// 			},
// 			...authentication,
// 		],
// 	},
// ]);

export default router;
